const serviceName = '/saude-preventiva'

const config = {
  prefix: `${serviceName}/api/v1`,
  serviceName,
}

export default config
